export const STORAGE_KEY = 'falmec-particles-params-v4'
export const FOLDERS_KEY = 'falmec-particles-folders'
export const PRESETS_KEY = 'falmec-particles-presets'

export const defaultParams = {
    // Aspetto
    particleSize: 0.033,
    particleShape: 0,
    shapeSoftness: 0.7,
    particleColor: '#00ffcc',
    colorShift: '#0044ff',
    backgroundColor: '#010a0f',
    opacityVariance: 1.53,
    colorVariance: 2.18,
    sizeVariance: 2.09,
    flashIntensity: 5.9,
    dimIntensity: 1.43,
    saturation: 1.0,
    // Campo di flusso
    flowInfluence: 0.5,
    flowStrength: 2,
    flowFrequency: 0.5,
    // Mouse
    mouseRadius: 10,
    mouseAspect: 3.0,
    suckStrength: 30.0,
    alwaysSuck: false,
    clickSuckEnabled: true,
    windStrength: 5.0,
    mouseTrail: 0,
    // Particelle
    particleCount: 20000,
    respawnRate: 0.3,
    spawnEdgeBias: 1.0, // 1 = spawn uniforme; <1 = piu' denso ai bordi, piu' rado al centro
    spawnEdgeFloor: 0.0, // quota di spawn uniforme miscelata: densita' minima garantita al centro
    // Fisica
    damping: 2.2,
    turbulenceStrength: 3.5,
    turbulenceFrequency: 1.8,
    // Gradiente forza spaziale (disattivo di default; usato dalla pagina carbon)
    forceGradEnabled: false,
    forceGradFloor: 0.35,
    forceGradVertical: 1.0,
    forceGradHorizontal: 1.0,
    forceGradPower: 1.0,
    symmetricField: false, // flow+turbolenza speculari rispetto all'asse x
    // Camera
    enableZoom: true,
    enablePan: true,
    enableRotate: true,
    autoRotate: false,
    autoRotateSpeed: 3.7,
    // Bloom
    bloomEnabled: true,
    bloomStrength: 0.72,
    bloomRadius: 0.33,
    bloomThreshold: 0.33,
    // Trail
    trailEnabled: true,
    trailAmount: 33.7,
    trailResolutionScale: 0.75,
    trailBlurAmount: 0.5,
    trailBrightPersist: 0.6,
    trailBlendMode: 0,
    // Profondità di campo
    dofEnabled: true,
    dofFocus: 18.0,
    dofAperture: 0.15,
    dofMaxBlur: 1.5,
    // HDR
    toneMapping: 4,
    exposure: 1.0,
    // Shape
    shape: 'text',
    shapeText: 'SMOKE',
    shapeScale: 1.0,
    // Morph
    morphEnabled: false,
    morphTarget: 'sphere',
    morphSpeed: 0.5,
    morphStrength: 5.0,
    // Corrente ascensionale + zone di esclusione testo (pagina carbon)
    updraftStrength: 0,
    textAvoidStrength: 0,
    textAvoidRadius: 2.0,
    textAvoidPadding: 28,
    textCorePadding: 8,
    textAvoidTip: 5.5,
    textAvoidTipDown: 2.2,
    textTipAttract: 0.08,
    textTipAttractRadius: 9,
    textAvoidSolid: true,
    textDodge: false,
    // Percorso predefinito stile "oryzo" (pagina carbon)
    pathEnabled: false,
    pathKinematic: false,
    flatten2D: false,
    pathAttraction: 0.8,
    pathDriftSpeed: 3,
    pathDriftRate: 2,
    pathWaveFreq: 0.7,
    pathWaveAmp: 0.6,
    pathWaveSpeed: 1.0,
    pathSpiralFreq: 0.8,
    pathRadius: 1.4,
    // Pattern di rinascita a noise (0 / -1 = disattivo, comportamento classico)
    spawnNoiseFreq: 0.3,
    spawnNoiseSpeed: 0.4,
    spawnNoiseAmp: 0,
    spawnNoiseGate: -1,
    // Barre di aspirazione fisse (lati)
    suctionBarsEnabled: true,
    suctionKillFactor: 0.4,
    suctionBarStrength: 200,
    suctionBarRadius: 11.2,
    suctionFadeSpeed: 0.375,
    suctionBar0Pos: { x: -11.876878155664922, y: 0, z: 0 },
    suctionBar0Size: { x: 0.3, y: 5, z: 0.5 },
    suctionBar1Pos: { x: 11.612455360927239, y: 0, z: 0 },
    suctionBar1Size: { x: 0.3, y: 5, z: 0.5 },
}
